import React from 'react'
import { LdsDualRingSpinnerDefault, LoadingOverlay } from './styled-elements'

const LoadingIndicator = ({show}) => (<LoadingOverlay show={show}>
  <LdsDualRingSpinnerDefault />
</LoadingOverlay>)

export default LoadingIndicator
